import Vue from 'vue'
import axios from './vue-axios/axios'

export function getTimeCodes(entity_id){
  return Vue.axios.get('/v1/entities/' + entity_id + '/time_codes')
}

export function getTimeCode(timeCodeId){
  return Vue.axios.get('/v1/time_codes/' + timeCodeId)
}

export function createTimeCode(timeCodeParams){
  return Vue.axios.post('/v1/time_codes', { time_code: timeCodeParams })
}

export function updateTimeCode(timeCodeParams){
  return Vue.axios.put('/v1/time_codes/' + timeCodeParams.id, { time_code: timeCodeParams })
}

export function checkTimeCodePermissions(timeCodeId){
  return Vue.axios.get(`/v1/time_codes/${timeCodeId}/permissions`)
}

export function deleteTimeCode(timeCodeId){
  return Vue.axios.delete('/v1/time_codes/' + timeCodeId)
}



// WEBPACK FOOTER //
// ./src/backend/timeCodes.js